import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div>
  <p className="align-center text-large">
    A JavaScript Primer for Learning React
  </p>
    </div>
    <p>{`React became really popular around the same time that ES2015 (ES6) came into existence (those are just the technical version names for JavaScript). For this reason, some beginners learning React are also trying to tackle more modern JavaScript syntax at the same time. If you're new to both, it can be confusing as to "what is JavaScript and what is React". This document should serve as a primer to help you get up-to-speed on JavaScript syntax that we feel matters the most for learning React.`}</p>
    <h2 {...{
      "id": "contents"
    }}><a parentName="h2" {...{
        "href": "#contents",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Contents`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#semicolons"
        }}>{`Semicolons`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#variables-var-let-and-const"
        }}>{`Variables: `}<code parentName="a" {...{
            "className": "language-text"
          }}>{`var`}</code>{`, `}<code parentName="a" {...{
            "className": "language-text"
          }}>{`let`}</code>{`, and `}<code parentName="a" {...{
            "className": "language-text"
          }}>{`const`}</code></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#template-literals"
        }}>{`Template Literals`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#expressions-vs-statements-and-declarations"
        }}>{`Expressions vs Statements and Declarations`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#functions"
        }}>{`Functions`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#arrow-functions-are-special"
            }}>{`Arrow Functions are Special`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#es2015-syntax-sugar"
        }}>{`ES2015 Syntax Sugar`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#shortand-for-object-methods"
            }}>{`Shorthand for Object Methods`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#object-destructuring"
            }}>{`Object Destructuring`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#array-destructuring"
            }}>{`Array Destructuring`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#property-shorthand"
            }}>{`Property Shorthand`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#spread-syntax"
            }}>{`...Spread Syntax`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#rest-syntax"
            }}>{`...Rest Syntax`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#es-modules"
            }}>{`ES Modules`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#arrays"
        }}>{`Arrays`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#arrayisarray"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`Array.isArray()`}</code></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#map"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`.map()`}</code></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#reduce"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`.reduce()`}</code></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#filter"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`.filter()`}</code></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#find"
            }}><code parentName="a" {...{
                "className": "language-text"
              }}>{`.find()`}</code></a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#short-circuiting-with-"
        }}>{`Short Circuiting with `}<code parentName="a" {...{
            "className": "language-text"
          }}>{`&&`}</code></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#optional-chaining-with-"
        }}>{`Optional Chaining with `}<code parentName="a" {...{
            "className": "language-text"
          }}>{`?.`}</code></a></li>
    </ul>
    <h2 {...{
      "id": "semicolons"
    }}><a parentName="h2" {...{
        "href": "#semicolons",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Semicolons`}</h2>
    <p>{`Perhaps you've heard or seen that semicolons aren't exactly required in JavaScript. There has been a ton of debate on whether or not devs should use them anyways, but the main points usually boil down to:`}</p>
    <ul>
      <li parentName="ul">{`Point: You should use them because there are some edge cases where not having them can be a problem`}</li>
      <li parentName="ul">{`Counterpoint: True, but if we use Babel to "transpile" our code, Babel is going to take the code we wrote without semicolons and it's going to add them back in for us anyways, so why does it matter?`}</li>
      <li parentName="ul">{`Counterpoint: Yes, but... `}<em parentName="li">{`and it goes on and on`}</em></li>
    </ul>
    <p>{`Whether you like or don't like them is totally up to you. One piece of tooling that seems to normalize the conversation a bit is `}<a parentName="p" {...{
        "href": "https://prettier.io"
      }}>{`prettier.io`}</a>{`, a formatting tool which rewrites the code as you type, or as you save, or as you push -- whichever you prefer. With tools like prettier, many of the "what is your preference" conversations are going away because tooling helps to normalize the code.`}</p>
    <h2 {...{
      "id": "variables-var-let-and-const"
    }}><a parentName="h2" {...{
        "href": "#variables-var-let-and-const",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Variables: `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`var`}</code>{`, `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`let`}</code>{`, and `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`const`}</code></h2>
    <p>{`JavaScript has always had `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`var`}</code>{`, which creates function-scope (or global scope). This can be a little confusing sometimes and is not often what we need.`}</p>
    <p>{`"Block Scope" can be easier to understand and manage which is why JavaScript got `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`let`}</code>{`, and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`const`}</code>{` in ES2015. Here's a quick rundown of how all three work:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`var\` is not block scope, it has global-scope in this`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// case. Here, \`name\` always refers to the same thing`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// because of that global scope.`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`var`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`var`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span>{`
  name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Bruce'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Bruce'`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`let\` is block scope. This means if we declare name with`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`let\` in the block of the if-statement, that \`name\` will`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// be "Bruce" inside that block, and the outer \`name\` will`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// still be "Michael"`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span>{`
  name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Bruce'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Michael'`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`const\` is also block scope like let`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span>{`
  name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Bruce'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
name `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 'Michael'`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The difference is that \`let\` can be reassigned`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` isOpen `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span>{`
isOpen `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span>{`
isOpen `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// false`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`const\` cannot be reassigned`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` isOpen `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span>{`
isOpen `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// throws error`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// \`const\` in JavaScript does not mean it's a super`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// global constant for the whole application like how`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// other languages might have. In JS, it just means`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// it's block scope and cannot be re-assigned for that `}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// block.`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Although const cannot be reassigned, if the value`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// is an array or an object, it's inner parts can be`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// changed, as long as the array or object itself isn't`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// reassigned`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` list `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The \`list\` will always be this array, we can't change`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// that, but we can modify the parts:`}</span>{`
list`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`push`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// But this is not allowed, we cannot change (reassign)`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// list to be something other than the array it started`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// off to be`}</span>{`
list `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'turn list into a string'`}</span></code></pre></div>
    <p>{`We find block scope to make more sense to people and is generally more useful. Personally, I never use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`var`}</code>{` anymore simply because it doesn't do anything I need. 99% of the time I use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`const`}</code>{` since I don't need re-assignment, and if I do re-assignment, I use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`let`}</code>{`. Others like to use let more often than const. Usually it doesn't really matter.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/const"
        }}>{`Read more on const`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/let"
        }}>{`Read more on let`}</a></li>
    </ul>
    <h2 {...{
      "id": "template-literal"
    }}><a parentName="h2" {...{
        "href": "#template-literal",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Template Literal`}</h2>
    <p>{`Strings in JavaScript can be made with single or double quotes. But when you make strings this way, you can't have multiline unless you manually add new lines. Template literals (sometimes referred to as Template strings) allow us to do multiline in a much cleaner way. Template literals use the back-tick instead of a single or double quote.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Manual hard returns with \\\\n isn't fun`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` str `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'multiline\\\\nwith\\\\nmanual\\\\nhard returns'`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// This is much nicer.`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` str `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  multiline
  without
  the
  mess
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span></code></pre></div>
    <p>{`Another benefit is string interpolation (making strings from variables)`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` something `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'ugly stuff'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` str `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'instead of '`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` something `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`' like this'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` something `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'lovely stuff'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` str `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`you can do `}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`something`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{` like this`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span></code></pre></div>
    <p>{`In the first example, the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`str`}</code>{` is being built with a variable. Notice we have to use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`+`}</code>{` concatenation to do so. In the second example, the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`str`}</code>{` is a Template literal which can use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`\${}`}</code>{` to interpolate variables into the string.`}</p>
    <p>{`When strings are made, the end result is no different if we use back-ticks, single quotes, or double quotes. So the fact that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`something`}</code>{` was made with single-quotes doesn't mean anything when it comes to using it as an interpolated variable into the template literal.`}</p>
    <p>{`JavaScript would even coerce numbers if needed:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` version `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`16`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` str `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`At the time of this writing, React is on version `}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`version`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span></code></pre></div>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals"
        }}>{`Read more about template literals`}</a></li>
    </ul>
    <h2 {...{
      "id": "expressions-vs-statements-and-declarations"
    }}><a parentName="h2" {...{
        "href": "#expressions-vs-statements-and-declarations",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Expressions vs Statements and Declarations`}</h2>
    <p>{`Most code in JavaScript is said to be either an `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Expressions_and_Operators"
      }}>{`Expression (Operator)`}</a>{` or `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements"
      }}>{`Declaration/Statement`}</a>{`. It's not so important to memorize every last detail about these, but it is important to know some things about expressions for React since only expressions are allowed in JSX and not statements or declarations.`}</p>
    <p>{`The brief definition is: Expressions resolve to a single value.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// If we're thinking in terms of statements, we might`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// write code like this, with an If-Statement:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`null`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`someCondition`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Here's how we might the same logic using a`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ternary operator, which is a type of expression`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// because the line of code resolves to a single`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// value for result`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` someCondition `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span></code></pre></div>
    <p>{`In this example, we have four separate expressions:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'michael jackson'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` parts `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`split`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' '`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// parts: ['michael', 'jackson']`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` first `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` parts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// first: 'michael'`}</span>{`
first `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` first`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`toUpperCase`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// first: 'MICHAEL'`}</span></code></pre></div>
    <p>{`Even though these are all expressions, JavaScript lets us combine and chain expressions together. In effect, all the expressions above can be rewritten into one expression:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'michael jackson'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` first `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` name`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`split`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' '`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`toUpperCase`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// We could have even done this:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` first `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'michael jackson'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`split`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' '`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`toUpperCase`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Chaining expressions looks funny at first if you're coming from a language that doesn't do this sort of thing, but if you read it left to right, each part is resolving to a value and then making itself available to the next part. When we do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`name.split(' ')`}</code>{`, this resolves to an array, which means the next part can pick off the 0 index with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`[0]`}</code>{`. That resolves to a string value of `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`'michael'`}</code>{` which can then have a string method added to it like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.toUpperCase()`}</code>{`. Whatever the far right side of the expression resolves to gets returned to the left-hand side of the equal sign, in our case a variable called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`first`}</code>{`.`}</p>
    <h2 {...{
      "id": "functions"
    }}><a parentName="h2" {...{
        "href": "#functions",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Functions`}</h2>
    <p>{`Functions in JavaScript can be created in several ways, each with different tradeoffs. Here are three ways to be aware of:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Function Declaration`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`getName`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Function Expression`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`getName`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Arrow Function (Which is also an expression)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`getName`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Based on the previous section on Declarations and Expressions, it's probably more clear as to why the first two get their names. The Function Expression is an "expression" because the function is being assigned to a value. Technically arrow functions are also expressions but conversationally we usually just refer to them as "arrow functions" and not "arrow function expressions".`}</p>
    <p>{`The tradeoffs between function declarations and expressions is that `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function#Function_declaration_hoisting"
      }}>{`declarations can be "hoisted"`}</a>{` and expressions cannot. However, many times hoisting doesn't matter so most developers choose one or the other simply based on personal syntax preference.`}</p>
    <h3 {...{
      "id": "arrow-functions-are-special"
    }}><a parentName="h3" {...{
        "href": "#arrow-functions-are-special",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Arrow Functions are Special`}</h3>
    <p>{`Arrow functions are function expressions with a slightly different syntax. In the example above, you can see that the arrow function looks just like function expression example but without the word function and then with a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`=>`}</code>{` fat arrow between the parens and the opening curly-brace.`}</p>
    <p>{`You may have heard that functions create their own scope in JavaScript. This means JavaScript functions create their own context for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`this`}</code>{` which can be problematic if we want a function but without having its own context for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`this`}</code>{`. One of the characteristics of an arrow function is that they don't create context so `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`this`}</code>{` inside the arrow function is the same as the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`this`}</code>{` on the outside. `}</p>
    <p>{`Arrow functions can also be really compact. Look at these two examples that do the exact same thing:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`getName`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Same as above but more compact`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`getName`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span></code></pre></div>
    <p>{`When arrow functions omit their curly-braces, it means we want the thing on the right-hand side of the fat arrow to be the return (without saying `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`return`}</code>{`). This is called an implicit return.`}</p>
    <p>{`There are some more subtle details to know about arrow functions like how to return an object literal and how to omit the parenthesis for a single parameter.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bradwestfall.com/articles/dont-get-javascript-es6-arrow-functions"
        }}>{`Read more about arrow functions`}</a></li>
    </ul>
    <h2 {...{
      "id": "es2015-syntax-sugar"
    }}><a parentName="h2" {...{
        "href": "#es2015-syntax-sugar",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`ES2015+ Syntax Sugar`}</h2>
    <p>{`ES2015-ES2018 has brought a lot of new syntax to JavaScript that lets us do things we could always do before, but now with nicer syntax. Here are some notable examples:`}</p>
    <h3 {...{
      "id": "shortand-for-object-methods"
    }}><a parentName="h3" {...{
        "href": "#shortand-for-object-methods",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Shortand for Object Methods`}</h3>
    <p>{`You can drop off the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`:`}</code>{` and the word `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`function`}</code>{` for methods when defining them:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` obj `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`insteadOfThis`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// do stuff`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`

  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`youCanDoThis`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// do stuff`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Note that the above is not an arrow function, just a shorter syntax for object methods.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Method_definitions"
        }}>{`Read more about method definitions`}</a></li>
    </ul>
    <h3 {...{
      "id": "object-destructuring"
    }}><a parentName="h3" {...{
        "href": "#object-destructuring",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Object Destructuring`}</h3>
    <p>{`Object destructuring is a way to take an object and to pull out its internal properties into variables outside of the object:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` obj `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` x`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// instead of:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` obj`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`x
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` y `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` obj`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`y

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// We can "destructure" the values into ordinary`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// variables:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` obj
x `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 1`}</span>{`
y `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 2`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// you can use this all over the place, like function`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// parameters. Notice how we're passing just one thing`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// (an object) into the add function. If the function`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// is expecting an argument, it can destructure the`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// values right in the parameter list.`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` x`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` y `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` y
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` x`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 7`}</span></code></pre></div>
    <p>{`It can be a little confusing at first because now curly-braces are used to make objects and to destructure them depending on context. So how can you tell?`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// If the curlies are on the right-hand sign of the`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// expression (equal sign) then we're making an object`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` obj `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` x`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// If they're on the left-hand side (or the receiving`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// side as with parameters), then it's destructuring:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` x `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` obj
x `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 1`}</span></code></pre></div>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#Object_destructuring"
        }}>{`Read more about object destructuring`}</a></li>
    </ul>
    <h3 {...{
      "id": "array-destructuring"
    }}><a parentName="h3" {...{
        "href": "#array-destructuring",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Array Destructuring`}</h3>
    <p>{`Array destructuring works almost the same as Object Destructuring but with square-brackets instead of curly-braces:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` arr `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'jackson'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`first`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` arr
first `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// michael`}</span>{`
last `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// jackson`}</span></code></pre></div>
    <p>{`The other difference between them is that objects have property names so those have to be used in the destructuring part. Since array values are numerically ordered and without names, the order that we destructure is tied to what value we get -- in other words, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`first`}</code>{` is the first variable in the destructure so it gets the first value of the array.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#Array_destructuring"
        }}>{`Read more about array destructuring`}</a></li>
    </ul>
    <h3 {...{
      "id": "property-shorthand"
    }}><a parentName="h3" {...{
        "href": "#property-shorthand",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Property Shorthand`}</h3>
    <p>{`Property Shorthand lets you type less if a property name matches the variable name in an object:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Instead of having to type name twice like this`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` name `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` person `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// If the property and the variable are the same you can just`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// type it like this and omit the colon and the double word`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` person `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` name `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#New_notations_in_ECMAScript_2015"
        }}>{`Read more about property shorthand syntax`}</a></li>
    </ul>
    <h3 {...{
      "id": "spread-syntax"
    }}><a parentName="h3" {...{
        "href": "#spread-syntax",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`...Spread Syntax`}</h3>
    <p>{`When creating objects or arrays, there is a new way to create properties from the properties of an existing object or array. This is much easier shown in code than explained:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Let's say you have this array`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` person `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Jackson'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// If you were to add the above array to a new one like this:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` profile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`person`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'developer'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The end result would be an array in an array like this:`}</span>{`
profile `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// [['Michael', 'Jackson'], 'developer']`}</span>{`

profile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// this is an array`}</span>{`
profile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// this is the string 'developer'`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// However, if we had made profile like this with ...`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` profile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`person`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'developer'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Then the end result would be this:`}</span>{`
profile `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ['Michael', 'Jackson', 'developer']`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The same concept works with objects`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` person `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` first`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Jackson'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` profile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`person`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` occupation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'developer'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
profile `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// { first: 'Michael', last: 'Jackson', occupation: 'developer' }`}</span></code></pre></div>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax"
        }}>{`Read more about spread syntax`}</a></li>
    </ul>
    <h3 {...{
      "id": "rest-syntax"
    }}><a parentName="h3" {...{
        "href": "#rest-syntax",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`...Rest Syntax`}</h3>
    <p>{`This might look similar to "spread" but the difference is that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`...`}</code>{` rest is not used to build objects or arrays, it's used to break then down into pieces. Here's an example of rest while destructuring:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` profile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` first`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Jackson'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` occupation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'developer'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` occupation`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`rest `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` profile
occupation `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// developer`}</span>{`
rest `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// { first: 'Michael', last: 'Jackson' }`}</span></code></pre></div>
    <p>{`Remember, destructuring is a way to break an object or an array apart into pieces. The above code makes an ordinary string variable called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`occupation`}</code>{` through destructuring. The three dots `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`...`}</code>{` followed by a variable name means we want all the rest of the properties into this `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`rest`}</code>{` object. Note that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`...`}</code>{` can be used while destructuring arrays as well. Also, the variable name doesn't have to be "rest". We could have done `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`...whatever`}</code>{`.`}</p>
    <p>{`The next form of rest comes in the form of function parameters:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`myFunction`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`first`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` last`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`...`}</span>{`rest`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` rest
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`myFunction`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Jackson'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Developer'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'California'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// output: ['Developer', 'California']`}</span></code></pre></div>
    <p>{`The function parameters is suggesting that it wants a first and last name as its first two arguments, but anything you pass in after that will all be added to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`rest`}</code>{` as an array.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment"
        }}>{`Read more about rest in destructuring`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters"
        }}>{`Read more about rest in parameters`}</a></li>
    </ul>
    <h3 {...{
      "id": "es-modules"
    }}><a parentName="h3" {...{
        "href": "#es-modules",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`ES Modules`}</h3>
    <p>{`Organizing and breaking your app into different re-usable files is key for a React application. Each JavaScript file is called a "module". In order to let modules work together, they need to be able to import and export code between them. While ES Modules aren't natively supported in browsers (yet), we use Webpack (or Rollup) and Babel to re-write our code that has modules into something the browser does understand.`}</p>
    <p>{`In NodeJS, the "pattern" developed for this is "CommonJS" or (cjs). Here's what it looks like:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` SomeModule `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'some-module'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
SomeModule`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`someMethod`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// more code here...`}</span>{`

module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` SomethingToExport`}</code></pre></div>
    <p>{`"ES Modules" is an alternative pattern that is mostly compatible with CommonJS but has a different syntax:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` SomeModule `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'some-module'`}</span>{`
SomeModule`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`someMethod`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// more code here...`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` SomethingToExport`}</code></pre></div>
    <p>{`Or we can do a destructuring-like syntax on the import:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` someMethod `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'some-module'`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`someMethod`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// more code here...`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` SomethingToExport`}</code></pre></div>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bradwestfall.com/articles/javascript-es6-modules-with-babel"
        }}>{`Read more about ES modules`}</a></li>
    </ul>
    <h2 {...{
      "id": "arrays"
    }}><a parentName="h2" {...{
        "href": "#arrays",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Arrays`}</h2>
    <p>{`Here are some common array methods and functions to be familiar with:`}</p>
    <h3 {...{
      "id": "arrayisarray"
    }}><a parentName="h3" {...{
        "href": "#arrayisarray",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a><code parentName="h3" {...{
        "className": "language-text"
      }}>{`Array.isArray()`}</code></h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Check to see if a value is an array`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` myArray `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'hello'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`Array`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`isArray`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// true`}</span></code></pre></div>
    <h3 {...{
      "id": "map"
    }}><a parentName="h3" {...{
        "href": "#map",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a><code parentName="h3" {...{
        "className": "language-text"
      }}>{`.map()`}</code></h3>
    <p>{`Map takes an array, iterates over it with a function and whatever the function returns will be the replacement value for the item we're currently on:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` myArray `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` item `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`result`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// [6, 7, 8, 9]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The above could have also been written like this with`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// an arrow function:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <h3 {...{
      "id": "reduce"
    }}><a parentName="h3" {...{
        "href": "#reduce",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a><code parentName="h3" {...{
        "className": "language-text"
      }}>{`.reduce()`}</code></h3>
    <p>{`Reduce is similar to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.map`}</code>{` in that it iterates over an array but the end result is just one value instead of replacing all the values in the array:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Let's add up all the values to get one value of 10`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` myArray `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` total `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`reduce`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`tally`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` current`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` tally `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` current
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`total`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// 10`}</span></code></pre></div>
    <p>{`The callback function will give us two important arguments. The first is a running tally of what we've made so far. The second is the current item we're iterating over (in our case the numbers). So, you can see that we're just taking what we have so far and adding each number to it. The only problem is we need tally to start off as `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0`}</code>{` otherwise the first iteration won't know how to add things. That's where the second argument for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`reduce()`}</code>{` comes in -- the first being the function and the second being a starting value for the "accumulator" which we're calling `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`tally`}</code></p>
    <p>{`The above could have also been written as an arrow function:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` total `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`reduce`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`tally`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` current`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` tally `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` current`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <h3 {...{
      "id": "filter"
    }}><a parentName="h3" {...{
        "href": "#filter",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a><code parentName="h3" {...{
        "className": "language-text"
      }}>{`.filter`}</code></h3>
    <p>{`Filter gives us a new array with the same values, but only if the iterator function returns `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`true`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` myArray `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`filter`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` isBiggerThanTwo `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` item `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` isBiggerThanTwo
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`result`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// [3, 4]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// An an arrow function`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` myArray`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`filter`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`result`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// [3, 4]`}</span></code></pre></div>
    <p>{`The first example clearly shows that we need to return a boolean based on if the input number is bigger than two. This can be simplified into an arrow function with an implicit return.`}</p>
    <h3 {...{
      "id": "find"
    }}><a parentName="h3" {...{
        "href": "#find",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a><code parentName="h3" {...{
        "className": "language-text"
      }}>{`.find`}</code></h3>
    <p>{`Find is similar to Filter but instead of returning an array, only the first item to get true returned from the iterator function is returned from Find:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` people `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` id`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Michael'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`id`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span>{` name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Bruce'`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` person `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` people`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`find`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`id `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`person`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// { id: 3, name: 'Michael'}`}</span></code></pre></div>
    <h2 {...{
      "id": "short-circuiting-with-"
    }}><a parentName="h2" {...{
        "href": "#short-circuiting-with-",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Short-Circuiting with `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`&&`}</code></h2>
    <p>{`You already know how `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{` works in If-Statements, but perhaps you didn't know they are used to do what is called "short circuiting". Here's how it works:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`one`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'one was called'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`two`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'two was called'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`false`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`one`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`two`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Here we go!'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// The only output of this code is "one was called" because of`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// short circuiting`}</span></code></pre></div>
    <p>{`The only output from this code is "one was called". The output for "Here we go!" is not going to happen because the two function calls return `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`false`}</code>{`. But why is the function `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`two()`}</code>{` not called at all? We know it wasn't called because we never get "two was called". The reason is that most programming languages short-circuit, which means when the thing before `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{` is false, then there's no point in checking the rest of the expression because one thing being false means the end result has to be false. Maybe you know most of that but never thought of it that way.`}</p>
    <p>{`Here's another way to take advantage of short-circuiting:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// This will cause an error if \`users\` is not an array`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`findById`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`users`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` users`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`find`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`id `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` id`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Now we are returning the person if \`users\` is an array`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// If \`users\` is not an array then false will be returned`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// because a falsy short circuit returns the left part`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// when falsy:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`findById`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`users`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` Array`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`isArray`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`users`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` users`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`find`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`id `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` id`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h2 {...{
      "id": "optional-chaining-with-"
    }}><a parentName="h2" {...{
        "href": "#optional-chaining-with-",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Optional Chaining with `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`?.`}</code></h2>
    <p>{`This one is used in similar cases to the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{` short-circuiting operator. It's actually the normal `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.`}</code>{` accessor operator with an additional feature. Let's say you wanted to access `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users.length`}</code>{` but `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users`}</code>{` is either an array or might be `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`null`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`undefined`}</code>{`. If you tried to do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users.length`}</code>{`, you might get:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Uncaught TypeError: Cannot read property 'length' of null`}</p>
    </blockquote>
    <p>{`So developers will do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users && users.length`}</code>{` to ensure it's not falsy (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`null`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`undefined`}</code>{`). Of course, this doesn't ensure the value is an array to get the length, but we'll address that coming up.`}</p>
    <p>{`Instead of doing the more verbose `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users && users.length`}</code>{`, you could `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users?.length`}</code>{` which does this:`}</p>
    <ul>
      <li parentName="ul">{`Evaluate `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`users`}</code>{` to see if it's truthy. If it isn't, return `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`undefined`}</code>{` from the expression without doing `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.length`}</code>{` to it.`}</li>
      <li parentName="ul">{`If it is truthy, then continue with the rest of the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.length`}</code>{` expression.`}</li>
    </ul>
    <p>{`Therefore, it will return `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`undefined`}</code>{` or the length depending on whether user is truthy. So you can see that it's very similar to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{` short-circuiting except that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`?.`}</code>{` will return `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`undefined`}</code>{` if the variable is "falsy" - not the actual "falsy" value of the variable like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{` would.`}</p>
    <p>{`In a previous short-circuit example, we checked to see if `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users`}</code>{` was an array before trying to do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.find`}</code>{` on it. This will be typical in JavaScript because there would be no other way of knowing that you do in-fact have an array. But in TypeScript, this check would be redundant since with types we know that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`users`}</code>{` is an array already:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "ts"
    }}><pre parentName="div" {...{
        "className": "language-ts"
      }}><code parentName="pre" {...{
          "className": "language-ts"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`findById`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`users`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` User`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`[`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`]`}</span>{` `}<span parentName="span" {...{
              "className": "token operator"
            }}>{`|`}</span>{` `}<span parentName="span" {...{
              "className": "token keyword"
            }}>{`null`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` id`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token builtin"
            }}>{`number`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` User `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`undefined`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` users`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`find`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`item`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` item`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`id `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` id`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`For this reason, I find myself using optional-chaining more often in TypeScript since I know the types and therefore don't need the additional check that would embrace `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`&&`}</code>{`.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Optional_chaining"
        }}>{`Read More`}</a></li>
    </ul>
    <h2 {...{
      "id": "summary"
    }}><a parentName="h2" {...{
        "href": "#summary",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Summary`}</h2>
    <p>{`The React community has really embraced modern JavaScript so learning React will most likely force you to learn the latest modern syntax after you read enough articles and documentation. I hope you enjoyed this read! If you're looking for more material on JavaScript, `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript"
      }}>{`Mozilla Developer Network`}</a>{` is a great place to start.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      